import React, { Component } from 'react';
import IncreaseIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import IconAlert from '../../../assets/image/alert_amount.png';
import IconAttach from '../../../assets/image/attach.png';
import IconDeleteFile from '../../../assets/image/delete_file.png';
import Iconfile from '../../../assets/image/file.png';
import { getOrderByNumber } from '../../../actions/ordersActions';
import { postCreateRequest } from '../../../actions/refundRequestsActions';
import { isArray } from "../../../helpers/functions";
import SnackBar from "../../HelperComponents/SnackBar/SnackBar";
import DefaultButton from "../../Buttons/DefaultButton/DefaultButton";
import { connect } from "react-redux";

const initialActiveItem = { amount: 1, price: 0, id: 0, lot: 0, name: '-', producer: '-', article_number: '-' };

class CreateRefundByOrderNumber extends Component {
    state = {
        activeItem: initialActiveItem,
        requestAmount: 1,
        requestSum: 0,
        searchValue: '',
        results: { data: [], query: '' },
        initSearch: false,
        files: [],
        loadingBtn: false,
        snackBarAttr: { isVisible: false, message: '', type: '' },
        comment: '',
        disabledBtn: true,
    };

    handleSearchChange = (e) => {
        const value = e.target.value.replace(/\D/g, '');
        this.setState({ searchValue: value });
    };

    handleSearchKey = (e) => {
        const { searchValue, results, initSearch } = this.state;
        if (searchValue.length >= 3 && results.query !== searchValue && searchValue.indexOf(" ") === -1) {
            this.props.dispatch(getOrderByNumber(searchValue)).then((res) => {
                var data = (res && res.payload && res.payload.data && res.payload.data.results) ? res.payload.data.results : [];
                this.setState({ initSearch: true, results: { data: data, query: searchValue } });
            });
        } else if (searchValue.length >= 3 && !initSearch) {
            this.setState({ initSearch: true });
        } else if (searchValue.length < 3 && searchValue !== "" && e.keyCode === 13) {
            this.props.dispatch(getOrderByNumber(searchValue)).then((res) => {
                var data = (res && res.payload && res.payload.data && res.payload.data.results) ? res.payload.data.results : [];
                this.setState({ initSearch: true, results: { data: data, query: searchValue } });
            });
        } else if (searchValue === "" || isArray(results.data)) {
            if (e.keyCode === 13) return;
            this.setState({
                initSearch: false,
                requestAmount: 1,
                requestSum: 0,
                activeItem: initialActiveItem
            });
        }
    };

    handleSelectItem = (index) => {
        const item = this.state.results.data[index];
        const sum = parseFloat(item.price);
        const disabled = !this.state.comment || !item.id;
        this.setState({
            activeItem: item,
            searchValue: item.id,
            requestAmount: 1,
            requestSum: sum,
            results: { data: [], query: '' },
            initSearch: false,
            disabledBtn: disabled,
        });
    };

    increaseAmount = () => {
        const { requestAmount, activeItem } = this.state;
        if (requestAmount < activeItem.amount) {
            const newVal = requestAmount + 1;
            this.setState({
                requestAmount: newVal,
                requestSum: parseFloat(activeItem.price * newVal),
            });
        }
    };

    decreaseAmount = () => {
        const { requestAmount, activeItem } = this.state;
        if (requestAmount > 1) {
            const newVal = requestAmount - 1;
            this.setState({
                requestAmount: newVal,
                requestSum: parseFloat(activeItem.price * newVal),
            });
        }
    };

    onChangeComment = (e) => {
        const value = e.target.value;
        this.setState({ comment: value });
    };

    componentDidUpdate(prevProps, prevState) {
        const { comment, activeItem } = this.state;
        const hasComment = comment && comment.trim().length > 0;
        const hasSelectedOrder = activeItem && activeItem.id && activeItem.id !== 0;
        const shouldBeDisabled = !hasComment || !hasSelectedOrder;
        
        if (prevState.disabledBtn !== shouldBeDisabled) {
            this.setState({ disabledBtn: shouldBeDisabled });
        }
    }

    handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            this.setState({ files: [...this.state.files, file] });
        }
        e.target.value = '';
    };

    handleAttachClick = (e) => {
        e.preventDefault();
        window.uploadInput.click();
    };

    handleRemoveFile = (index) => {
        const files = [...this.state.files];
        files.splice(index, 1);
        this.setState({ files });
    };

    toggleSnackBar = () => {
        this.setState({ snackBarAttr: { isVisible: false, message: '', type: '' } });
    };

    submitRequest = () => {
        this.setState({ loadingBtn: true });
        const { files, activeItem, requestAmount, requestSum, comment } = this.state;
        const { dispatch, toggleDialog, createRefundRequest, refetch } = this.props;

        const formData = new FormData();
        files.forEach(file => formData.append('files', file, file.name));
        
        const ordersData = [
            {
                order: activeItem.id,
                amount: requestAmount,
                price: requestSum
            }
        ];
        
        formData.append('orders', JSON.stringify(ordersData));
        formData.append('price', requestSum);
        formData.append('ordernum', activeItem.ordernum);
        formData.append('comment', comment);
        formData.append('amount', requestAmount);

        dispatch(postCreateRequest(formData)).then(res => {
            if (res && res.payload && res.payload.status === 201) {
                this.setState({
                    snackBarAttr: { isVisible: true, message: 'Заявка успешно создана', type: 'success' },
                    loadingBtn: false,
                });
                toggleDialog();
                createRefundRequest(true);
                refetch();
            } else {
                this.setState({
                    snackBarAttr: {
                        isVisible: true,
                        message: (res && res.error && res.error.response && res.error.response.data && res.error.response.data.error && res.error.response.data.error[0]) || 'Произошла ошибка. Повторите попытку позже.',
                        type: 'error',
                    },
                    loadingBtn: false,
                });
                createRefundRequest(false);
            }
        });
    };

    render() {
        const { activeItem, requestAmount, requestSum, searchValue, results, initSearch, files, loadingBtn, comment, snackBarAttr, disabledBtn } = this.state;

        return (
            <>
                <div className="dialog-form-wrapper">
                    <div className="requests_add">
                        <div className="requests_add_search">
                            <span>Номер заказа</span>
                            <input
                                type="text"
                                className='requests_add_search-input'
                                placeholder="Введите номер заказа"
                                value={searchValue}
                                onChange={this.handleSearchChange}
                                onKeyUp={this.handleSearchKey}
                                autoComplete="off"
                            />
                            {initSearch &&
                                <div className="search_products_list">
                                    {isArray(results.data) ? results.data.map((el, index) => (
                                        <div className="search_product_item" key={el.id} onClick={() => this.handleSelectItem(index)}>
                                            <div className="search_product_item_head"><span>{el.id}</span></div>
                                            <div className="search_product_item_info">
                                                <div><span className="block_label">Товар</span><p className="block_value">{el.name}</p></div>
                                                <div><span className="block_label">Артикул</span><p className="block_value">{el.article_number}</p></div>
                                                <div><span className="block_label">Производитель</span><p className="block_value">{el.producer}</p></div>
                                                <div><span className="block_label">Количество</span><p className="block_value">{el.amount}</p></div>
                                                <div className="block_value_currency">{el.price}<div className="ru_value"> ₽</div></div>
                                            </div>
                                        </div>
                                    )) : <li>Нет совпадений</li>}
                                </div>
                            }
                        </div>

                        {/* Количество и сумма */}
                        <div className="amount_requests">
                            <div>
                                <span className="descriptions_amount">Количество</span>
                                <div className="block_amount">
                                    <div className="amount">
                                        <button className="minus" disabled={activeItem.id === 0 || requestAmount <= 1} onClick={this.decreaseAmount}><RemoveIcon /></button>
                                        <span>{requestAmount}</span>
                                        <button className="plus" disabled={requestAmount === activeItem.amount} onClick={this.increaseAmount}><IncreaseIcon /></button>
                                    </div>
                                    <div className="info_amount"><img src={IconAlert} alt="IconAlert" /> Количество товара для оформления возврата</div>
                                </div>
                            </div>
                            <div className="price_all">
                                <span className="descriptions_amount">Сумма</span>
                                <div className="price">{requestSum.toFixed(2)} ₽</div>
                            </div>
                        </div>

                        {/* Информация о заказе */}
                        <div className="search_products_list selected_order">
                            <div className="search_product_item">
                                <div className="search_product_item_head"><span>Информация о выбранном заказе</span></div>
                                <div className="search_product_item_info">
                                    <div><span className="block_label">Товар</span><p className="block_value">{activeItem.name}</p></div>
                                    <div><span className="block_label">Артикул</span><p className="block_value">{activeItem.article_number}</p></div>
                                    <div><span className="block_label">Производитель</span><p className="block_value">{activeItem.producer}</p></div>
                                    <div className="block_value_currency">{activeItem.price}<div className="ru_value"> ₽</div></div>
                                </div>
                            </div>
                        </div>

                        {/* Комментарий и файлы */}
                        <div className="block_textarea_amount">
                            <span>Комментарий</span>
                            <textarea placeholder="Ваш комментарий" onChange={this.onChangeComment} value={comment}></textarea>
                        </div>
                        <div className="attach_file_block">
                            <input type="file" hidden ref={ref => window.uploadInput = ref} onChange={this.handleFileChange} />
                            <button className="attach_btn" onClick={this.handleAttachClick}>
                                <img src={IconAttach} alt="attach" /> Прикрепить файл
                            </button>
                            {files.map((file, i) => (
                                <div className="document_info" key={i}>
                                    <img className="doc_icon" src={Iconfile} alt="file" />
                                    <span>{file.name}</span>
                                    <button className="btn_delete_doc" onClick={() => this.handleRemoveFile(i)}>
                                        <img src={IconDeleteFile} alt="delete" />
                                    </button>
                                </div>
                            ))}
                        </div>
                        <div className="btn-wrapper order-dialog-btn">
                            <DefaultButton variant="outlined" classes="cancel_btn" onClick={this.props.toggleDialog}>Отмена</DefaultButton>
                            <DefaultButton loading={loadingBtn} disabled={loadingBtn || disabledBtn} onClick={this.submitRequest}>Создать заявку</DefaultButton>
                        </div>
                    </div>
                </div>
                <SnackBar
                    open={snackBarAttr.isVisible}
                    classes={snackBarAttr.type}
                    vertical="top"
                    onClose={this.toggleSnackBar}
                >
                    {snackBarAttr.message}
                </SnackBar>
            </>
        );
    }
}

export default connect()(CreateRefundByOrderNumber);
